import { en } from "./en";
import { bn } from "./bn";
import type { Dictionary } from "./types";

export type Locale = "en" | "bn";

export const LOCALES: Locale[] = ["en", "bn"];
export const DEFAULT_LOCALE: Locale = "en";

const dictionaries: Record<Locale, Dictionary> = { en, bn };

export const getDict = (locale: Locale): Dictionary => dictionaries[locale];

export const isLocale = (v: unknown): v is Locale =>
  v === "en" || v === "bn";

export type { Dictionary } from "./types";
